import * as React from 'react'

import { cn } from './cn'

export interface PaperProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'elevation' | 'outlined'
  elevation?: number
  square?: boolean
  component?: React.ElementType
}

const Paper = React.forwardRef<HTMLDivElement, PaperProps>(
  (
    {
      variant = 'elevation',
      elevation = 1,
      square,
      component: Component = 'div',
      className,
      ...props
    },
    ref,
  ) => (
    <Component
      ref={ref}
      className={cn(
        'bg-paper text-text-primary',
        !square && 'rounded-card',
        variant === 'outlined'
          ? 'border border-divider'
          : elevation > 0 && 'border border-divider shadow-paper',
        className,
      )}
      {...props}
    />
  ),
)
Paper.displayName = 'Paper'

export default Paper
